/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useEffect, useState } from "react";
import Container from "common/components/Container/Container";
import i18n from "internationalization/i18n";
// import { useGetChargersQuery } from "services/chargersService";
import {
  userApi,
  useGetUsersQuery,
  useCreateUserMutation,
} from "services/userService";
import { useGenerateStationCodeMutation, useGetStationCodesQuery, stationAPI } from "services/stationService";
import { useDispatch, useSelector } from "react-redux";
import { rootReducerType } from "../../redux/combineReducers";
import useWindowDimensions, {
  counterCommonItemsArrays,
  decodeJWT,
  getDataToDisplay,
} from "../../common/functions";
import { Button, Modal, Input, Select, DatePicker, Form } from "antd";
import "./StationCodes.less";
import SelectFilter from "../../common/components/Select/Select";
import UsersTable from "../../common/components/UsersTable/UsersTable";
import StationCodesTable from "../../common/components/StationCodesTable/StationCodesTable";
import { useGetStationsQuery } from "../../services/stationsService";
import { emailToUsername, getUpperCase } from "../../common/utils";
import { UserItem, PricingItem } from "services/utils/interfaces";
import Notification from "common/components/NotificationMessage/Notification";
import moment from "moment";
import { useGetMenuQuery } from "services/dashboardService";

type Props = {
  shouldRefresh: boolean;
};

export type StationCodes = Array<UserItem>;
export type Pricing = Array<PricingItem>;

const StationCodes: React.FC<Props> = ({
  shouldRefresh,
}): React.ReactElement => {
  const getFilterBy = (): string | undefined =>
    filter &&
    [
      i18n.t("chargers.station"),
      i18n.t("chargers.type"),
      "Active",
      i18n.t("chargers.status"),
    ].includes(filter)
      ? filter
      : undefined;

  const getFilterQueryString = (
    key: string | null,
    filterBy: string | undefined,
    filterValue: string | null
  ) =>
    filterBy && filterValue
      ? key?.toLowerCase() + "_is_" + filterValue
      : undefined;

  const getKey = (filterBy?: string): string | null =>
    filterBy
      ? filterBy === "Station"
        ? "stationId"
        : filterBy.toLowerCase()
      : null;

  const getSortBy = (sort: string | null): string | undefined =>
    sort ? sort : undefined;

  const { isLoggedIn } = useSelector(
    (state: rootReducerType) => state.authenticationReducer
  );
  const [params, setParams] = useState({
    userName: emailToUsername(decodeJWT(isLoggedIn).email),
  });
  const { data: menuData } = useGetMenuQuery(params);

  const [list, setList] = useState<any>([]);
  useEffect(() => {
    if (menuData) {
      const dashboardMenu = menuData[0].Dashboard;
      const lists: any = [];
      for (let i = 0; i < dashboardMenu.length; i++) {
        if (dashboardMenu[i] == "All") {
        } else {
          lists.push({
            value: dashboardMenu[i]["locationId.stationId"],
            label: dashboardMenu[i]["stationName"],
          });
        }
      }
      setList(lists);
    }
  }, [menuData]);

  const [limit] = useState(10);
  const [offset, setOffset] = useState<number>(0);
  const [previousOffset, setPreviousOffset] = useState<number>(offset);

  const [stationCodes, setStationCodes] = useState<StationCodes>([]);

  const statusData = [
    i18n.t("chargers.available"),
    i18n.t("chargers.inUse"),
    i18n.t("chargers.unavailable"),
    i18n.t("chargers.offline"),
    i18n.t("chargers.faulted"),
  ];
  const typeData = [i18n.t("chargers.level2"), i18n.t("chargers.dcfc")];
  const ActiveData = ["true", "false"];

  const dispatch = useDispatch();

  const [filter, setFilter] = useState<string | null>(null);
  const [filterValue, setFilterValue] = useState<string | null>(null);
  const [sort, setSort] = useState<string | null>(null);
  const [reset, setReset] = useState(false);

  const { data, refetch } = useGetStationCodesQuery({
    userName: emailToUsername(decodeJWT(isLoggedIn).email),
    limit: String(limit),
    offset: String(offset < 0 ? 0 : offset),
    sortBy: getSortBy(sort),
    filterBy: getFilterQueryString(
      getKey(getFilterBy()),
      getFilterBy(),
      filterValue
    ),
  });

  useEffect(() => {
    if (offset < previousOffset) return;
    if (offset === previousOffset) {
      const tempOffset = offset < 0 ? 0 : offset;
      dispatch(
        stationAPI.endpoints.getStationCodes.initiate(
          {
            userName: emailToUsername(decodeJWT(isLoggedIn).email),
            limit: String(limit),
            offset: String(tempOffset),
            sortBy: getSortBy(sort),
            filterBy: getFilterQueryString(
              getKey(getFilterBy()),
              getFilterBy(),
              filterValue
            ),
          },
          { subscribe: false, forceRefetch: true }
        )
      );
    }
    // setReset(false);
  }, [offset]);

  useEffect(() => {
    const tempOffset = offset <= 0 ? offset - 1 : 0;
    setOffset(tempOffset);
    setPreviousOffset(tempOffset);
  }, [filterValue, sort]);

  useEffect(() => {
    if (!data?.items) return;
    const tempOffset = offset < 0 ? 0 : offset;
    setOffset(tempOffset);
    setPreviousOffset(tempOffset);
    const counterCommonItems = counterCommonItemsArrays(
      data.items,
      stationCodes
    );
    const newItems = JSON.parse(
      JSON.stringify(
        offset <= 0
          ? [...data.items]
          : counterCommonItems === 0
          ? [...stationCodes, ...data.items]
          : [...stationCodes]
      )
    );
    setStationCodes(newItems);
    setPreviousOffset(offset);
  }, [JSON.stringify(data?.items), offset, reset]);

  useEffect(() => {
    if (!reset) {
      setReset(false);
    }
    refetch();
  }, [refetch, reset]);

  useEffect(() => {
    refetch();
  }, [shouldRefresh]);

  const selectItems = [{ option: "Station" }, { option: "Active" }];

  const handleReset = () => {
    const tempOffset = offset <= 0 ? offset - 1 : 0;
    setReset(true);
    setFilter(null);
    setFilterValue(null);
    setSort(null);
    setOffset(tempOffset);
    setPreviousOffset(tempOffset);
  };

  const { width } = useWindowDimensions();

  const [loading, setLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);

  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const [locaStationId, setLocaStationId] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [expireAt, setExpireAt] = useState<string>("");
  const [momentTime, setMomentTime] = useState<moment.Moment>(moment());

  const cancelTap = () => {
    setOpen(false);
  };

  const [createUser, { isSuccess: createUserSuccess, data: createUserData }] =
    useCreateUserMutation();
  const [
    generateStationCode,
    { isSuccess: generateStationCodeSuccess, data: generateStationCodeData },
  ] = useGenerateStationCodeMutation();

  useEffect(() => {
    if (createUserSuccess) {
      Notification({
        type: createUserData?.success ? "success" : "warning",
        message: createUserData?.success
          ? createUserData.message
          : "request failed",
        description: "",
      });
      handleCancel();
	  refetch();
    }
  }, [createUserSuccess]);

  useEffect(() => {
    if (generateStationCodeSuccess) {
      Notification({
        type: generateStationCodeData?.success ? "success" : "warning",
        message: generateStationCodeData?.success
          ? generateStationCodeData.message
          : "request failed",
        description: "",
      });
      handleCancel();
    }
  }, [generateStationCodeSuccess]);

  const saveTap = () => {
    generateStationCode({
      selectedStation: locaStationId,
      email,
      expireAt,
    });
  };

  const generateCode = () => {
    setOpen(true);
  };

  useEffect(() => {
	if (!reset) {
		setReset(false);
	}
	refetch();
}, [refetch, reset]);

  // 自定义日期不可用的函数
  const disabledDate = (current) => {
    // 只允许选择当前日期之后的日期
    return current && current <= currentDate.startOf("minute");
  };

  const currentDate = moment();

  const onChange = (dateString) => {
    // 'YYYY-MM-DDTHH:mm:ss'
    // const newStartDate = moment(dateString).format().toString();
    // 'YYYY-MM-DDTHH:mm:ss' without timezone offset
    const newStartDate = moment(dateString).format("YYYY-MM-DDTHH:mm:ss");
    setExpireAt(newStartDate);
  };

  return (
    <Container
      backButton={false}
      loadingPageName={i18n.t("stationCodes.pageName")}
      subTitle={i18n.t("stationCodes.subtitle")}
      renderCondition={data ? true : false}
    >
      <div className="table">
        <div className="sessions-title">
          <div>
            {/* <SelectFilter
              selectedFilter={filter || undefined}
              selectedFilterValue={filterValue || undefined}
              setNewFilter={(value) => setFilter(value)}
              setNewFilterValue={(value) => setFilterValue(value)}
              items={selectItems}
              statusData={statusData}
              typeData={typeData}
              ActiveData={ActiveData}
              stationData={stationData}
              reset={reset}
              setReset={setReset}
            />
            <Button onClick={handleReset} className="dark-button">
              Reset filters
            </Button> */}
          </div>
          <Button className="dark-button" onClick={() => generateCode()}>
            {i18n.t("stationCodes.generateCode")}
          </Button>
        </div>
        {data ? (
          <StationCodesTable
            limit={limit}
            offset={offset < 0 ? 0 : offset}
            setOffset={setOffset}
            data={getDataToDisplay(stationCodes, limit, offset)}
            setNewSort={(value) => setSort(value)}
            shouldReset={(value) => setReset(value)}
            reset={reset}
            length={stationCodes.length + (stationCodes.length < limit ? 0 : 1)}
          />
        ) : null}
      </div>
      <Modal
        visible={open}
        title="Generate a station code"
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
        width={500}
      >
        <div className="model-content model-content-team">
          <Form
            initialValues={{ remember: true }}
            onFinish={saveTap}
            autoComplete="off"
          >
            <div className="model-content-item3">
              <p>{i18n.t("stationCodes.email")}: </p>
              <Form.Item
                label=""
                name="email"
                rules={[{ required: true, message: "Please enter the email." }]}
              >
                <Input
                  style={{ width: 220 }}
                  placeholder="User email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Item>
            </div>
            <div className="model-content-item3">
              <p>{i18n.t("stationCodes.station")}: </p>
              <Form.Item
                label=""
                name="stations"
                rules={[{ required: true, message: "Please select stations." }]}
              >
                <Select
                  allowClear
                  style={{ width: 220 }}
                  placeholder="Please select"
                  // defaultValue={[]}
                  onChange={(e) => setLocaStationId(e)}
                  options={list}
                />
              </Form.Item>
            </div>
            <div className="model-content-item3">
              <p>{i18n.t("stationCodes.expireAt")}: </p>
              <Form.Item
                label=""
                name="expireAt"
                rules={[
                  {
                    required: true,
                    message: "Please select an expiration date.",
                  },
                ]}
              >
                <DatePicker
                  disabledDate={disabledDate}
                  style={{ width: 220, fontSize: "25px" }}
                  showTime // 启用时间选择
                  format="YYYY-MM-DD HH" // 设置日期时间格式
                  placeholder="Select Date and Time"
                  onChange={(value, dateString) => onChange(dateString)}
                  defaultValue={momentTime}
                />
              </Form.Item>
            </div>

            <div className="model-last-btn">
              <Form.Item style={{ width: "48%" }}>
                <Button
                  type="primary"
                  danger
                  size="large"
                  style={{
                    margin: "10px 0",
                    height: "40px",
                    width: "100%",
                    background: "#FD6B7E",
                    fontSize: "16px",
                  }}
                  onClick={() => cancelTap()}
                >
                  {i18n.t("teams.cancel")}
                </Button>
              </Form.Item>
              <Form.Item style={{ width: "48%" }}>
                <Button
                  type="primary"
                  danger
                  size="large"
                  htmlType="submit"
                  style={{
                    background: "#FF9F39",
                    border: "1px solid #FF9F39",
                    height: "40px",
                    width: "100%",
                    fontSize: "16px",
                    fontWeight: "800",
                  }}
                >
                  {i18n.t("teams.save")}
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>

        {/* <div className='model-content'>
						<div className='model-content-item'>
							<p> Expire at: </p>
							<DatePicker
								disabledDate={disabledDate}
								style={{ width: 220, fontSize: '25px' }}
								showTime // 启用时间选择
								format="YYYY-MM-DD HH:ss" // 设置日期时间格式
								placeholder="Select Date and Time"
								onChange={(value, dateString) => onChange(dateString)}
								defaultValue={momentTime}
							/>
						</div>

						<div className='model-content-item'>
							<p> Station: </p>
							<Select
								showSearch
								style={{ width: 220 }}
								placeholder="Select a station"
								onChange={(value) => setLocaStationId(value)}
								options={list}
							/>
						</div>
						<div className='model-content-item'>
							<p>Email address: </p>
							<Input style={{ width: 220 }} placeholder="email"
								value={email} onChange={(e) => setEmail(e.target.value)} />
						</div>
						<div className='model-last-btn'>
							<Button type="primary" danger size='large'
								style={{ margin: "10px 0", height: '50px', width: '50%', background: '#FD6B7E' }}
								onClick={() => cancelTap()}>cancel</Button>
							<Button type="primary" danger size='large'
								style={{
									background: '#FF9F39', border: '1px solid #FF9F39', height: '50px',
									width: '50%', fontSize: '20px', fontWeight: '800'
								}} onClick={() => saveTap()}>save</Button>
						</div>
					</div> */}
      </Modal>
    </Container>
  );
};

export default StationCodes;
